export const SET_CHALLENGE = "SET_CHALLENGE";
export const DELETE_CHALLENGE = "DELETE_CHALLENGE";
export const SET_CHALLENGE_DISCUSSION = "SET_CHALLENGE_DISCUSSION";
export const SET_LOADED_STATUS = "SET_LOADED_STATUS";
export const SET_CHALLENGE_LEADERBOARD = "SET_CHALLENGE_LEADERBOARD";
export const SET_CHALLENGE_AGGREGATE = "SET_CHALLENGE_AGGREGATE";
export const SET_ALL_CHALLENGE_PACKAGES = "SET_ALL_CHALLENGE_PACKAGES";
export const SET_CHALLENGE_PACKAGES_FOR_BUILDER =
  "SET_CHALLENGE_PACKAGES_FOR_BUILDER";
export const SENT_CHALLENGE_INVITES = "SENT_CHALLENGE_INVITES";
export const SET_ALL_MEMBERS_INVITED = "SET_ALL_MEMBERS_INVITED";
export const SET_REFRESH_JOINED_STATUS_NEEDED =
  "SET_REFRESH_JOINED_STATUS_NEEDED";
export const SET_MOBILE_CHALLENGE = "SET_MOBILE_CHALLENGE";
export const SET_CHALLENGE_MILESTONES = "SET_CHALLENGE_MILESTONES";
